import { Col, Row } from "antd";
import Card from "antd/es/card/Card";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { dataWrapper, getClaims, navigateAction } from "../../../redux/actions";
import formatAmount from "../../../utility/formatAmount";
import "./Appointment.less";
import dayjs from "dayjs";
import { selectFUNC, STRING_DATE } from "../../../const/constant";
import { Claim } from "../../../types/RequestTypes";
import ChooseClaimModal from "../../component/ChooseClaimModal";

function ApptCard(props) {
  const {
    duty,
    index,
    staffNo,
    device,
    navigate,
    functions,
    setCurrEA,
    dataFetch,
    fetchClaims,
    reject_duty,
    setIsChooseClaim,
  } = props;

  const colSpan =
    device.size === "mobile"
      ? 24
      : device.size === "tablet"
      ? 12
      : device.view === "container-ig"
      ? 6
      : 8;

  // let totalRejectAmt: number = 0;
  let reject_count: number = 0;
  let rejectCountObj = reject_duty.find(
    (x) => x.SP_DUTY_PK === duty.SP_DUTY_PK
  );
  if (rejectCountObj) {
    // totalRejectAmt = rejectCountObj.TOT_REJECT_AMT;
    reject_count = rejectCountObj.REJECT_CLAIM_COUNT;
  }

  const getRequestView = async (duty, staffNo) => {
    //If duty is hourly, go to Request with hourly prop
    const func = selectFUNC(duty.RATE_TYPE, functions);
    //FETCH claims
    const claims = await fetchClaims(duty.SP_DUTY_PK);
    //FETCH endorser and approver
    const eaList = await dataFetch(
      `ptps/getEAList?code=${duty.DEPT_CODE}&duty_pk=${duty.SP_DUTY_PK}`,
      {},
      "GET"
    );
    if (
      eaList?.value?.approverList &&
      eaList?.value?.endorserList &&
      claims?.value?.DUTY
    ) {
      setCurrEA(eaList.value.approverList, eaList.value.endorserList);
      if (
        // (duty.RATE_TYPE === "M" || duty.RATE_TYPE === "L") &&
        reject_count > 0
      ) {
        setIsChooseClaim(true);
      } else {
        navigate(func);
      }
    }
  };

  //const clicked_css : React.CSSProperties = {"height" : "100%", "backgroundColor" : "#656565", "color" : 'white'}
  const non_clicked_css: React.CSSProperties = { height: "100%" };

  const cardClass = reject_count > 0 ? "reject-card" : "polyu-color-card";
  const remainingHr: number = duty.HR_MAX - duty.HR_PAID;

  return (
    <Col span={colSpan} key={`${index}_${staffNo}`}>
      <Card
        onClick={() => getRequestView(duty, staffNo)}
        style={non_clicked_css}
        className={cardClass}
        title={
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ width: "50%" }}>{duty.DT_DESC}</div>
              {reject_count > 0 ? (
                <div
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    textAlign: "right",
                    width: "50%",
                  }}
                >
                  Payment Request(s) Rejected
                </div>
              ) : (
                <></>
              )}
            </div>
            <div>{duty.POST_TITLE}</div>
          </>
        }
        hoverable={true}
      >
        <Row gutter={[0, { xs: 4, sm: 4, md: 6, lg: 8 }]}>
          <Col span={12}>Dept:</Col> <Col span={12}>{duty.DEPT_ABBR}</Col>
          <Col span={device.size === "desktop" ? 12 : 24}>Duty Period:</Col>
          <Col span={device.size === "desktop" ? 12 : 24}>
            {dayjs(duty.START_DATE).format(STRING_DATE)} to{" "}
            {dayjs(duty.END_DATE).format(STRING_DATE)}
          </Col>
          {duty.RATE_TYPE === "L" && (
            <>
              <Col span={12}>Lump Sum:</Col>{" "}
              <Col span={12}>{formatAmount(duty.LUMP_SUM)}</Col>
              <Col span={12}>Remaining:</Col>{" "}
              <Col span={12}>
                {formatAmount(
                  parseFloat(duty.LUMP_SUM) -
                    parseFloat(duty.LUMP_SUM_PAID ? duty.LUMP_SUM_PAID : 0)
                )}
              </Col>
            </>
          )}
          {duty.RATE_TYPE === "H" && (
            <>
              <Col span={12}>Hourly Rate:</Col>{" "}
              <Col span={12}>{formatAmount(duty.HR_RATE)}</Col>
              <Col span={12}>Remaining:</Col>{" "}
              <Col span={12}>
                {parseFloat(`${remainingHr}`).toFixed(2)} hr(s)
              </Col>
            </>
          )}
          {duty.RATE_TYPE === "M" && (
            <>
              <Col span={12}>Monthly Rate:</Col>{" "}
              <Col span={12}>{formatAmount(duty.MONTHLY_RATE)}</Col>
            </>
          )}
          <Col span={12}>Prog/Proj Code:</Col>{" "}
          <Col span={12}>{duty.PROG_PROJ_CODE}</Col>
          <Col span={device.size === "desktop" ? 12 : 24}>
            Prog/Proj Title:
          </Col>{" "}
          <Col span={device.size === "desktop" ? 12 : 24}>
            {duty.PROG_PROJ_TITLE}
          </Col>
        </Row>
      </Card>
    </Col>
  );
}

function Appointment(props) {
  //React fetch components
  const {
    appointments,
    claims,
    setSelectClaim,
    currDuty,
    functions,
    navigate,
  } = props;
  //appointments _map. Cards
  const [isChooseClaim, setIsChooseClaim] = useState(false);
  const [claimOptions, setClaimOptions] =
    useState<{ value: number; label: string }[]>();
  const [selectClaimPK, setSelectClaimPK] = useState<number>();

  useEffect(() => {
    if (claims && !_.isEmpty(claims)) {
      //Filter claims by rejected
      const f_claims = claims.filter((c) => c.STATUS === "R");
      if (!_.isEmpty(f_claims)) {
        const newClaimOptions = getClaimOptions(f_claims);
        setClaimOptions(newClaimOptions);
        setSelectClaimPK(f_claims[0].SP_SUP_CLAIM_PK);
      }
    }
  }, [claims]);

  //navigate
  const navigateCurrDuty = () => {
    const func = selectFUNC(currDuty.RATE_TYPE, functions);
    navigate(func);
  };

  const getClaimOptions = (claims: Claim[]) => {
    if (claims[0]?.TOT_HR_CLAIM && claims[0].TOT_HR_CLAIM > 0) {
      const combinedClaimDtl: Claim[] = claims.reduce(
        (acc: Claim[], current: Claim) => {
          const sameBatchNoClaim = acc.find(
            (e) => e.BATCH_NO === current.BATCH_NO
          );
          if (sameBatchNoClaim) {
            acc = acc.filter((e) => e.BATCH_NO !== current.BATCH_NO);
            const newClaimOption = {
              ...sameBatchNoClaim,
              START_DATE:
                dayjs(sameBatchNoClaim.START_DATE) < dayjs(current.START_DATE)
                  ? sameBatchNoClaim.START_DATE
                  : current.START_DATE,
              END_DATE:
                dayjs(sameBatchNoClaim.END_DATE) > dayjs(current.END_DATE)
                  ? sameBatchNoClaim.END_DATE
                  : current.END_DATE,
            };
            acc.push(newClaimOption);
          } else {
            acc.push(current);
          }
          return acc;
        },
        []
      );
      return combinedClaimDtl.map((claim: Claim) => {
        return {
          value: claim.SP_SUP_CLAIM_PK,
          label: `${claim.BATCH_NO}: ${dayjs(claim.START_DATE).format(
            STRING_DATE
          )} to ${dayjs(claim.END_DATE).format(STRING_DATE)}`,
        };
      });
    } else {
      return claims.map((claim: Claim) => {
        return {
          value: claim.SP_SUP_CLAIM_PK,
          label: `${claim.BATCH_NO}: ${dayjs(claim.START_DATE).format(
            STRING_DATE
          )} to ${dayjs(claim.END_DATE).format(STRING_DATE)}`,
        };
      });
    }
  };

  const getAppts = (staffNo, appts) => {
    const ApptList = [] as React.ReactNode[];
    let i = 0;

    for (const duty of appts) {
      i = i + 1;
      ApptList.push(
        ApptCard({ duty, index: i, staffNo, setIsChooseClaim, ...props })
      );
    }
    return (
      <Row gutter={[16, 16]} key={`gutter_${staffNo}`}>
        {ApptList}
      </Row>
    );
  };

  const getStaff = (staffs) => {
    const StaffList = [] as React.ReactNode[];
    for (const [sn, staff] of Object.entries<Object>(staffs)) {
      StaffList.push(
        <Row
          key={`line_${sn}`}
          id="step1Label"
          className="d-print-none"
          style={{ display: "flex", justifyContent: "flex-start" }}
        >
          <Col className="form-sect-title theme-color-text">
            <span className="d-block" style={{ textAlign: "center" }}>
              Appointments under Staff No: {sn}
            </span>
          </Col>
          {/* <Col className="form-sect-title theme-color-text">
                    <span className="d-block" style={{'textAlign': 'center'}}>Staff Name: {staff[0].STAFF_NAME}</span>
                </Col> */}
        </Row>
      );
      StaffList.push(getAppts(sn, staff));
    }
    return StaffList;
  };

  const staffs = _.groupBy(appointments, "STAFF_NO");

  return (
    <>
      {claimOptions && (
        <ChooseClaimModal
          isChooseClaim={isChooseClaim}
          setIsChooseClaim={setIsChooseClaim}
          claimOptions={claimOptions}
          selectClaimPK={selectClaimPK}
          setSelectClaimPK={setSelectClaimPK}
          onConfirmSubmit={() => {
            setSelectClaim(
              claims.find((c) => c.SP_SUP_CLAIM_PK === selectClaimPK)
            );
            navigateCurrDuty();
          }}
        />
      )}
      <div style={{ paddingTop: "10px", paddingBottom: "20px" }}>
        {_.isEmpty(staffs) ? (
          <div>No Appointments found</div>
        ) : (
          getStaff(staffs)
        )}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    appointments: state.data.appointments,
    functions: state.dashboard.functions,
    device: state.session.device,
    reject_duty: state.data.reject_duty,
    claims: state.data.claims,
    currDuty: state.data.currDuty,
  };
};

const mapDispatchToProps = (dispatch) => ({
  navigate: (toFunctions) => {
    dispatch(navigateAction(toFunctions));
  },
  setCurrEA: (approver, endorser) => {
    dispatch({
      type: "SET-CURR-EA",
      payload: { value: { approver, endorser } },
    });
  },
  dataFetch: (apiPath, data, method) => {
    return dispatch(dataWrapper(apiPath, data, method));
  },
  fetchClaims: (duty_pk) => {
    return dispatch(getClaims(duty_pk));
  },
  setSelectClaim: (select_claim) => {
    dispatch({ type: "SELECT-CLAIM", payload: { value: { select_claim } } });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Appointment);
